var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy-advisory"},[_c('div',{staticClass:"banner"},[_c('div',{staticClass:"bannerImg"})]),_c('header',{staticClass:"wrap-header"},[_c('h3',[_vm._v("政策咨询")])])])
}]

export { render, staticRenderFns }